import { Link } from "gatsby";
import React from "react";
import CILogoColoured from "../../../assets/icons/CILogoColoured.svg";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";

export const TopBanner = ({
  phone,
  email,
}: {
  phone: string | undefined | null;
  email: string | undefined | null;
}) => {
  return (
    <div className="flex justify-between items-center w-full relative px-6 py-3">
      <Link to="/" className="block" aria-label="Return to Home Page">
        <img
          src={CILogoColoured}
          alt="Christie &amp; Finance Logo"
          className="w-auto h-12"
        />
      </Link>
      <div className="flex">
        {phone && (
          <div className="flex items-center justify-end px-3 flex-1 gap-x-6">
            <a
              href={"tel:" + phone}
              className="text-lg px-2 font-semibold hover:text-lime-600 hover:decoration-2 hover:underline-offset-2 first:pr-4 flex items-center gap-2"
            >
              <PhoneIcon className="w-5 h-5 mt-0.5" />
              {phone}
            </a>
          </div>
        )}
        {email && (
          <div className="flex items-center justify-end px-3 flex-1 gap-x-6">
            <a
              href={"mailto:" + email}
              className="text-lg px-2 font-semibold hover:text-lime-600 hover:decoration-2 hover:underline-offset-2 first:pr-4 flex items-center gap-2"
            >
              <EnvelopeIcon className="w-5 h-5 mt-0.5" />
              {email}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
